import * as React from 'react';

import { useTypeGuard } from 'af-root/hooks/useTypeGuard';

import styles from './styles.module.scss';

interface PropsForDelete {
	withDelete: true;
	index: number;
	onDelete: (index: number) => void;
}

type GuardedPropsForDelete = GuardedBy<PropsForDelete, 'withDelete'>;

interface PropsForResetChanges {
	withResetChanges: true;
	materialId: number;
	onResetChanges: (materialId: number) => void;
}

type GuardedPropsForResetChanges = GuardedBy<PropsForResetChanges, 'withResetChanges'>;

type Props = GuardedPropsForDelete & GuardedPropsForResetChanges;

export type DeleteAndUndoCellProps = Props;

function hasDelete(props: GuardedPropsForDelete): props is PropsForDelete {
	return props.withDelete === true;
}

function hasResetChanges(props: GuardedPropsForResetChanges): props is PropsForResetChanges {
	return props.withResetChanges === true;
}

const DeleteAndUndoCell: React.FC<Props> = (props) => {
	const propsForResetChanges = useTypeGuard(props, hasResetChanges);
	const propsForDelete = useTypeGuard(props, hasDelete);

	const handleDelete = React.useCallback(() => {
		if (!propsForDelete) {
			return;
		}
		const { onDelete, index } = propsForDelete;
		onDelete(index);
	}, [propsForDelete]);

	const handleResetChanges = React.useCallback(() => {
		if (!propsForResetChanges) {
			return;
		}
		const { materialId, onResetChanges } = propsForResetChanges;
		onResetChanges(materialId);
	}, [propsForResetChanges]);

	return (
		<div className={styles.deleteAndUndoCell}>
			{!!propsForDelete && (
				<span className={`${styles.icon} ${styles.delete} icon-delete`} onClick={handleDelete} />
			)}
			{!!propsForResetChanges && (
				<span className={`${styles.icon} icon-rotate_left`} onClick={handleResetChanges} />
			)}
		</div>
	);
};

export default React.memo(DeleteAndUndoCell);
